import React from 'react';
import splitOnFirst from 'split-on-first';
import {
  FormattedDate, FormattedMessage, useIntl,
} from 'react-intl';
import {
  isLineItemCancelled, getCategoryName, isReviewGroupLead,
} from '@printdeal/business-logic';
import { Grid, Panel, ValidationMessage } from '@printdeal/ui-library';
import LineItemState from '../../shared/Elements/LineItemState/LineItemState';
import ArtworkThumbnail from '../../ArtworkThumbnail';
import { getFinalDeliveryDate } from '../../../helpers/order-helper';
import LineItem from '../../../../../types/cart/LineItem';

import { Environment } from '../../../../../helpers/env';

interface ComplaintOrderLineItemProps {
  lineItem: LineItem;
}

const ComplaintOrderLineItem = ({
  lineItem,
}: ComplaintOrderLineItemProps) => {
  const { locale } = useIntl();
  const { totalGroupQuantity, quantity } = lineItem;
  const lineItemQuantity = isReviewGroupLead(lineItem) ? totalGroupQuantity : quantity;
  const lineItemCustomFields = lineItem?.custom?.fields || {
    lineItemNumber: undefined,
    localizedProductName: undefined,
    mcpDocumentsSource: undefined,
    merchandisingProductName: undefined,
    productKey: undefined,
    userSelection: undefined,
    variableAttributes: undefined,
    revisedPromisedArrivalDateV2: undefined,
    revisedPromisedArrivalDate: undefined,
    promisedArrivalDate: undefined,
  };
  const deliveryDate = getFinalDeliveryDate({
    revisedPromisedArrivalDateV2: lineItemCustomFields.revisedPromisedArrivalDateV2,
    revisedPromisedArrivalDate: lineItemCustomFields.revisedPromisedArrivalDate,
    promisedArrivalDate: lineItemCustomFields.promisedArrivalDate,
  });
  const productName = getCategoryName(lineItem, locale);

  return (
    <Panel>
      <Grid className="pd-grid-cols-12 pd-gap-4">
        <Grid.Item className="pd-z-20 pd-col-span-4 lg:pd-col-span-2">
          <ArtworkThumbnail
            lineItem={lineItem}
            documentReference={lineItemCustomFields.mcpDocumentsSource && splitOnFirst(lineItemCustomFields.mcpDocumentsSource[0], ':')[1]}
            userSelection={lineItemCustomFields.userSelection}
            isDeliveredFileValid
          />
        </Grid.Item>
        <Grid.Item className="pd-z-10 pd-col-span-8 lg:pd-col-span-5">
          <div className="pd-font-bold">
            {`${productName}, `}
            <FormattedMessage
              id="account.order.orderline.quantity"
              defaultMessage="{quantity} {quantity, plural, one {piece} other {pieces}}"
              values={{ quantity: lineItemQuantity }}
            />
          </div>
          {!isLineItemCancelled(lineItem, Environment) && (
          <ValidationMessage variant="dim" className="pd-mt-1">
            <FormattedMessage
              id="account.order.deliveryDate"
              defaultMessage="Order delivery date"
            />
            {' '}
            <FormattedDate
              value={deliveryDate}
              year="numeric"
              month="long"
              day="2-digit"
            />
          </ValidationMessage>
          )}
          <div className="pd-mt-3 pd-text-dim-500">
            <LineItemState lineItem={lineItem} className="pd-mb-3 pd-cursor-pointer" />
          </div>
        </Grid.Item>
      </Grid>
    </Panel>
  );
};

export default ComplaintOrderLineItem;
